import { type OmitKeys, RecordUtils } from "@rsm-hcd/javascript-core";
import type { BlockConfiguration } from "models/interfaces/block-configurations/block-configuration";

const blockConfigurationDefaultValues: BlockConfiguration =
    RecordUtils.auditableDefaultValuesFactory({
        blockId: 0,
    });

type ExcludeBaseBlockConfiguration<TConfiguration extends BlockConfiguration> =
    OmitKeys<TConfiguration, BlockConfiguration>;

export const blockConfigurationDefaultValuesFactory = <
    TConfiguration extends BlockConfiguration,
>(
    specificBlockTypeDefaultConfigurationValues: ExcludeBaseBlockConfiguration<TConfiguration>
): BlockConfiguration & ExcludeBaseBlockConfiguration<TConfiguration> => ({
    ...blockConfigurationDefaultValues,
    ...specificBlockTypeDefaultConfigurationValues,
});

export interface BlockConfigurationRecord extends BlockConfiguration {
    toJS(): BlockConfiguration;
    with(values: Partial<BlockConfiguration>): BlockConfigurationRecord;
}
